export default __webpack_public_path__ + "static/media/personal-poster.26e4363d.svg";